import { AsYouType, CountryCode } from "libphonenumber-js"

// Separate from phone-utils so the booking store, which only validates numbers,
// does not ship the as-you-type formatter on every route.
const PHONE_SIGNIFICANT_CHAR = /[\d+]/

export function countPhoneSignificantChars(value: string) {
  let count = 0
  for (const char of value) {
    if (PHONE_SIGNIFICANT_CHAR.test(char)) count++
  }
  return count
}

/**
 * Progressive formatting for a phone input. `previousValue` is the formatted
 * value before this edit, used to detect a deletion of only formatting
 * characters, which AsYouType would otherwise re-add immediately.
 */
export function formatPhoneAsYouType(
  value: string,
  previousValue: string,
  defaultCountry: CountryCode = "US"
): string {
  let next = value
  if (
    next.length < previousValue.length &&
    new AsYouType(defaultCountry).input(next) === previousValue
  ) {
    let editAt = 0
    while (editAt < next.length && next[editAt] === previousValue[editAt]) {
      editAt++
    }
    const before = next.slice(0, editAt).replace(/[\d+](?=[^\d+]*$)/, "")
    next = before + next.slice(editAt)
  }
  return new AsYouType(defaultCountry).input(next)
}
